export class Referential {
    uuid!:string;
    name?:string;
    sector?:string;
    city?:string;
    topic?:string;
    refClass?:string;
    period?:string;
    year?:number;
}
